<div>
  <div class="SummaryContent">
    <div id="nonStyleGrid">
      <kendo-grid [scrollable]="'none'" [kendoGridBinding]="acdsummarydata">
        <kendo-grid-column field="label" title="Change Item Type" [width]="240">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="link">
              <a (click)="navigateToBuilds(dataItem.id ?? 0)" [attr.data-value]="dataItem.id">{{ dataItem.label }}</a>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="totalAdd" title="Count Of Add" [width]="240">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="gridDataField">
              {{ dataItem.totalAdd }}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="totalChange" title="Count Of Change" [width]="240">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="gridDataField">
              {{ dataItem.totalChange }}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="totalDelete" title="Count Of Delete" [width]="240">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="gridDataField">
              {{ dataItem.totalDelete }}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="totalNoChange" title="Count Of No-Change" [width]="240">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="gridDataField">
              {{ dataItem.totalNoChange }}
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
    <div class="submitBtn">
      <button class="primarybtn" *ngIf="showSubmitBtn" (click)="submitAcdRequest()">Submit Request</button>
    </div>
  </div>

</div>
<app-content-popup *ngIf="popupShow" [dialogTitle]="popupTitle" [width]="popupWidth" [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)">
  <ng-container>
    <app-obselute-items-popup [setCRNo]="crNo" (closeContentPopUp)="closeActionPopup($event)"></app-obselute-items-popup>
  </ng-container>
</app-content-popup>